function t(n) {
  return function() {
    return n;
  };
}
export {
  t as default
};
